import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../../node_modules/@flixbus/honeycomb/dist/scss/components/calendar.scss.js';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../../../packages/props-utils/prop-types.js';
import { isSameDate, isInDateRange } from '../../calendar-utils.js';
import { CalendarDayPropType } from '../../calendar-factory/build-calendar-day.js';

const bem = new HoneyBem('calendar', styles);
function CalendarBody(_ref) {
  let {
    weeks,
    startSelected,
    endSelected,
    selected,
    hoveredEndDate,
    setHoveredEndDate,
    setDisplayedMonth,
    handleSelect = () => null,
    dayLabel = (d, m, y) => "".concat(new Date(y, m, d).toLocaleDateString()),
    month,
    year,
    currentDate
  } = _ref;
  // mouse over events to update range highlight
  const handleDateEnter = date => {
    setHoveredEndDate(date);
  };
  const handleDateLeave = () => {
    setHoveredEndDate(endSelected);
  };
  const isRangeHighlight = date => {
    if (startSelected && endSelected) {
      return isInDateRange(date, startSelected, endSelected);
    }
    if (startSelected && hoveredEndDate) {
      return isInDateRange(date, startSelected, hoveredEndDate);
    }
    return false;
  };
  const isSelected = date => selected && isSameDate(date, selected);
  const isStartDate = date => startSelected && isSameDate(date, startSelected);
  const isEndDate = date => endSelected && isSameDate(date, endSelected);
  const cellClassNames = date => bem.e('cell', {
    selected: isSelected(date),
    start: isStartDate(date),
    end: isEndDate(date),
    range: isRangeHighlight(date),
    current: currentDate && isSameDate(date, new Date())
  });
  return /*#__PURE__*/React.createElement("tbody", null, weeks.map(days => (/*#__PURE__*/React.createElement("tr", {
    key: "w-".concat(days[0].date.getFullYear(), "-").concat(days[0].date.getMonth(), "-").concat(days[0].number)
  }, days.map(_ref2 => {
    let {
      number,
      date,
      disabled,
      prev,
      next
    } = _ref2;
    return /*#__PURE__*/React.createElement("td", Object.assign({
      role: "gridcell",
      key: "".concat(date.getFullYear(), "-").concat(date.getMonth(), "-").concat(date.getDate()),
      className: cellClassNames(date),
      "aria-disabled": disabled,
      "aria-selected": isSelected(date) || isStartDate(date) || isEndDate(date) ? 'true' : undefined
    }, currentDate && isSameDate(currentDate, new Date()) ? {
      'aria-current': 'date'
    } : {}), !prev && !next && disabled && (/*#__PURE__*/React.createElement("span", {
      className: bem.e('btn', 'disabled')
    }, number)), !prev && !next && !disabled && (/*#__PURE__*/React.createElement("button", {
      className: bem.e('btn'),
      onClick: () => {
        setDisplayedMonth(date);
        if (handleSelect) handleSelect(date);
      },
      onMouseEnter: () => handleDateEnter(date),
      onFocus: () => handleDateEnter(date),
      onMouseLeave: handleDateLeave,
      onBlur: handleDateLeave,
      type: "button",
      disabled: disabled,
      "aria-label": dayLabel(number, month, year),
      "aria-pressed": isSelected(date) || isStartDate(date) || isEndDate(date) ? 'true' : false
    }, number)));
  })))));
}
CalendarBody.displayName = 'CalendarBody';
CalendarBody.propTypes = {
  weeks: PropTypes.arrayOf(PropTypes.arrayOf(CalendarDayPropType)).isRequired,
  startSelected: PropTypes.instanceOf(Date),
  endSelected: PropTypes.instanceOf(Date),
  selected: PropTypes.instanceOf(Date),
  currentDate: PropTypes.instanceOf(Date),
  setDisplayedMonth: PropTypes.func.isRequired,
  handleSelect: PropTypes.func,
  dayLabel: PropTypes.func,
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired
};

export { CalendarBody };
